export const getMonth = (deadline) => {
  const monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = new Date(deadline).getMonth();

  return monthList[month];
};

export const getDate = (deadline) => {
  return new Date(deadline).getDate();
};
